export default __webpack_public_path__ + "static/media/download_p4.9bd6ab57.jpg";